// eslint-disable-next-line import/namespace
import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export const getRevieweeListApi = (reviewCycle) => {
  const url = endpoints.reviews.reviewActionPlan.revieweeList(reviewCycle);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getActionPlanListApi = ({ reviewCycle, revieweeId }) => {
  const url = endpoints.reviews.reviewActionPlan.actionPlanList({ reviewCycle, revieweeId });
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const createPOAOneOnOneAgendaApi = ({ newAgenda, reviewCycle, actionPlanId, instanceId }) => {
  const url = endpoints.reviews.reviewActionPlan.oneOnOne.agendaCreate({ reviewCycle, actionPlanId });
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: newAgenda,
    queryParams: {
      instanceId,
    },
  });
};

export const createPOACompetencyInitiativeApi = ({ newInitiative, reviewCycle, actionPlanId, competencyId }) => {
  const url = endpoints.reviews.reviewActionPlan.competencies.addInitiative({ reviewCycle, actionPlanId });
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: newInitiative,
    queryParams: {
      competencyId,
    },
  });
};

export const deleteActionPlanItemApi = ({ reviewCycle, actionPlanId }) => {
  const url = endpoints.reviews.reviewActionPlan.deleteActionPlan({ reviewCycle, actionPlanId });
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
};

export const addActionPlanItemApi = ({ newActionPlanItem, reviewCycle, revieweeId }) => {
  const url = endpoints.reviews.reviewActionPlan.addActionPlanItem({ reviewCycle, revieweeId });
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: newActionPlanItem,
  });
};

export const editActionPlanItemApi = ({ editedActionPlanItem, reviewCycle }) => {
  const { reviewActionPlanId: actionPlanId, actionItemText, isCompleted, tag } = editedActionPlanItem;
  const url = endpoints.reviews.reviewActionPlan.editActionPlanItem({ reviewCycle, actionPlanId });
  return sendRequest({
    url,
    method: 'PATCH',
    credentials: 'include',
    body: {
      actionItemText,
      isCompleted,
      tag,
    },
  });
};
